class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.isComingSoon = this.dataset.comingSoon === 'true';
    this.stickyBar = this;
    this.mainSection = document.getElementById('pp-' + this.dataset.sectionId) || document.getElementById(this.dataset.sectionId);
    if (!this.mainSection) {
      console.warn('[StickyATC] Could not find main product section.');
      return;
    }
    this.purchaseSection = this.mainSection.querySelector('.pp-block-buy_buttons') || this.mainSection.querySelector('.pp-info-column') || this.mainSection;
    this.variantSelect = this.querySelector('.sticky-atc-variant-select');
    this.qtyInput = this.querySelector('.sticky-atc-qty');
    this.qtyMinusBtn = this.querySelector('.sticky-atc-qty-minus');
    this.qtyPlusBtn = this.querySelector('.sticky-atc-qty-plus');
    this.submitBtn = this.querySelector('.sticky-atc-btn');
    this.priceElement = this.querySelector('.sticky-atc-price');
    this.compareAtPriceElement = this.querySelector('.sticky-atc-compare-price');
    this.imageElement = this.querySelector('.sticky-atc-image');
    this.variantTextElement = this.querySelector('.sticky-atc-variant-text');

    this.init();
  }

  init() {
    this.setupScrollListener();

    if (this.variantSelect) {
      this.variantSelect.addEventListener('change', this.onVariantChange.bind(this));
    }

    // Initialize with current variant if available
    if (this.variantSelect) {
      this.updateDetailsFromVariant(this.variantSelect.options[this.variantSelect.selectedIndex]);
    }

    // Quantity +/- buttons
    if (this.qtyMinusBtn) {
      this.qtyMinusBtn.addEventListener('click', () => {
        let val = parseInt(this.qtyInput.value) || 1;
        if (val > 1) this.qtyInput.value = val - 1;
      });
    }

    if (this.qtyPlusBtn) {
      this.qtyPlusBtn.addEventListener('click', () => {
        let val = parseInt(this.qtyInput.value) || 1;
        this.qtyInput.value = val + 1;
      });
    }
  }

  setupScrollListener() {
    if (!this.purchaseSection) return;

    const checkVisibility = () => {
      const rect = this.purchaseSection.getBoundingClientRect();
      const isPastForm = rect.bottom < 0;

      if (isPastForm) {
        this.stickyBar.classList.add('is-visible');
      } else {
        this.stickyBar.classList.remove('is-visible');
      }
    };

    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility, { passive: true });
    checkVisibility();
  }

  onVariantChange(event) {
    const selectedOption = event.target.options[event.target.selectedIndex];
    this.updateDetailsFromVariant(selectedOption);

    // Sync with main form hidden variant input
    const mainVariantInput = this.mainSection.querySelector('input[name="id"]');
    if (mainVariantInput) {
      mainVariantInput.value = selectedOption.value;
      mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Sync with main form select if exists
    const mainSelect = this.mainSection.querySelector('select[name="id"]');
    if (mainSelect) {
      mainSelect.value = selectedOption.value;
      mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  updateDetailsFromVariant(option) {
    if (!option) return;

    // Update Price
    if (this.priceElement && option.dataset.price) {
      this.priceElement.innerHTML = option.dataset.price;
    }

    // Update Compare at Price
    if (this.compareAtPriceElement) {
      if (option.dataset.compareAtPrice) {
        this.compareAtPriceElement.innerHTML = option.dataset.compareAtPrice;
        this.compareAtPriceElement.style.display = 'inline-block';
      } else {
        this.compareAtPriceElement.style.display = 'none';
      }
    }

    // Update Image
    if (this.imageElement && option.dataset.image) {
      this.imageElement.src = option.dataset.image;
    }

    // Update variant text
    if (this.variantTextElement && option.dataset.title && option.dataset.title !== 'Default Title') {
      this.variantTextElement.innerHTML = option.dataset.title;
      this.variantTextElement.style.display = 'block';
    } else if (this.variantTextElement) {
      this.variantTextElement.style.display = 'none';
    }

    // Update button state
    if (this.submitBtn) {
      if (this.isComingSoon) {
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = 'Coming Soon';
        return;
      }

      if (option.dataset.available === 'true') {
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = 'ADD TO CART';
      } else {
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = 'SOLD OUT';
      }
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
